import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import Spin from '../Spin';
import { imageClass } from './styles';
import { PureComponent } from '../component';

var Magnify =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Magnify, _PureComponent);

  var _super = _createSuper2(Magnify);

  function Magnify(props) {
    var _this;

    _classCallCheck(this, Magnify);

    _this = _super.call(this, props);
    _this.element = void 0;
    _this.state = {
      loading: true,
      status: 0,
      style: {
        maxHeight: props.maxHeight,
        maxWidth: props.maxWidth
      }
    };
    _this.handleMove = _this.handleMove.bind(_assertThisInitialized(_this));
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.handleLoaded = _this.handleLoaded.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Magnify, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.src !== this.props.src && this.state.status === 1) {
        // eslint-disable-next-line
        this.setState({
          loading: true,
          status: 0,
          style: {
            maxHeight: this.props.maxHeight,
            maxWidth: this.props.maxWidth
          }
        });
        this.props.lockScroll(false);
      }
    }
  }, {
    key: "move",
    value: function move(clientX, clientY) {
      var rect = this.element.getBoundingClientRect();
      var image = this.element.querySelector('img');
      var width = rect.width - 100;
      var height = rect.height - 100;
      var x = (clientX - rect.left - 50) / width;
      var y = (clientY - rect.top - 50) / height;
      this.element.scrollTop = (image.offsetHeight - height) * y;
      this.element.scrollLeft = (image.offsetWidth - width) * x;
    }
  }, {
    key: "handleLoaded",
    value: function handleLoaded() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: "handleMove",
    value: function handleMove(e) {
      this.move(e.clientX, e.clientY);
    }
  }, {
    key: "handleResize",
    value: function handleResize(e) {
      var _this2 = this;

      var _this$props = this.props,
          maxHeight = _this$props.maxHeight,
          maxWidth = _this$props.maxWidth,
          position = _this$props.position;
      if (position !== 'center') return;
      var status = this.state.status === 1 ? 0 : 1;
      var clientX = e.clientX,
          clientY = e.clientY;
      this.setState(immer(function (state) {
        state.status = status;
        state.style = status === 0 ? {
          maxHeight: maxHeight,
          maxWidth: maxWidth
        } : undefined;
      }), function () {
        if (status === 0) return;

        _this2.move(clientX, clientY);
      });
      this.props.lockScroll(status === 1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          maxHeight = _this$props2.maxHeight,
          maxWidth = _this$props2.maxWidth,
          src = _this$props2.src;
      var _this$state = this.state,
          status = _this$state.status,
          loading = _this$state.loading; // eslint-disable-next-line

      var cursor = this.props.position === 'center' ? status === 1 ? 'zoom-out' : 'zoom-in' : 'pointer';
      var style = {
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        cursor: cursor
      };

      if (status === 1) {
        style.overflow = 'scroll';
        style.borderRightWidth = 0;
        style.borderBottomWidth = 0;
      }

      var onMouseMove = status === 1 ? this.handleMove : undefined;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleResize,
          onMouseMove: onMouseMove,
          ref: function ref(el) {
            _this3.element = el;
          },
          style: style,
          className: imageClass('magnify')
        },
        /*#__PURE__*/
        React.createElement("img", {
          onLoad: this.handleLoaded,
          src: src,
          alt: "",
          style: this.state.style
        }), loading &&
        /*#__PURE__*/
        React.createElement("div", {
          className: imageClass('magnify-loading')
        },
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 30
        })))
      );
    }
  }]);

  return Magnify;
}(PureComponent);

export default Magnify;